if (!customElements.get("content-tabs")) {
  customElements.define(
    "content-tabs",
    class ContentTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(
          this.querySelectorAll("[data-content-tabs-button]")
        );
        this.panels = Array.from(
          this.querySelectorAll("[data-content-tabs-panel]")
        );

        if (this.buttons.length === 0 || this.panels.length === 0) return;

        this._onTabClick = (event) =>
          this._activateTab(event.currentTarget.dataset.tabId);

        this.buttons.forEach((button) => {
          button.addEventListener("click", this._onTabClick);
        });

        // Nested blocks cannot resolve their own index in Liquid, so the first
        // tab is opened here; the CSS fallback covers the no-JS case.
        if (!this.buttons.some((button) => button.classList.contains("is-active"))) {
          this._activateTab(this.buttons[0].dataset.tabId);
        }
      }

      disconnectedCallback() {
        this.buttons?.forEach((button) => {
          button.removeEventListener("click", this._onTabClick);
        });
      }

      _activateTab(tabId) {
        if (!tabId) return;

        this.buttons.forEach((button) => {
          const isActive = button.dataset.tabId === tabId;
          button.classList.toggle("is-active", isActive);
          button.setAttribute("aria-selected", String(isActive));
        });

        this.panels.forEach((panel) => {
          panel.classList.toggle("is-active", panel.dataset.tabId === tabId);
        });
      }
    }
  );
}
